var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.emails.length > 0
    ? _c("div", { staticClass: "container" }, [
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "jumbotron" },
          [
            _c("h1", { staticClass: "display-4" }, [
              _vm._v("Sharing " + _vm._s(_setup.resourceName)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "lead" }, [
              _vm._v("Send notification for shared "),
              _c("strong", [_vm._v(_vm._s(_setup.resourceName))]),
              _vm._v(" owned by "),
              _c("strong", [_vm._v(_vm._s(_setup.organizationName))]),
              _vm._v(" data in TransparentChoice application"),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._l(_setup.emails, function (e) {
              return _c(
                "div",
                { staticClass: "form-check form-check-inline" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.selectedEmails,
                        expression: "selectedEmails",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: `email_${e}` },
                    domProps: {
                      value: e,
                      checked: Array.isArray(_setup.selectedEmails)
                        ? _vm._i(_setup.selectedEmails, e) > -1
                        : _setup.selectedEmails,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _setup.selectedEmails,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = e,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_setup.selectedEmails = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_setup.selectedEmails = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _setup.selectedEmails = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: `email_${e}` },
                    },
                    [_vm._v(_vm._s(e))]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.message,
                  expression: "message",
                },
              ],
              staticClass: "form-control",
              attrs: { placeholder: "Optianal message here" },
              domProps: { value: _setup.message },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _setup.message = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-lg btn-secondary m-1",
                attrs: {
                  href: `/#/sharing/resource/${_setup.resourceProviderName}/${_setup.resourceId}`,
                  disabled: _setup.invokingSendNotificationCommandV1,
                },
              },
              [_vm._v("Skip")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-primary pull-right m-1",
                attrs: {
                  disabled:
                    _setup.selectedEmails.length == 0 ||
                    _setup.invokingSendNotificationCommandV1,
                },
                on: { click: _setup.invokeSendNotificationCommandV1 },
              },
              [_vm._v("Send")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _setup.succeedSendNotificationCommandV1,
                    expression: "succeedSendNotificationCommandV1",
                  },
                ],
                staticClass: "alert alert-primary mt-5",
                attrs: { role: "alert" },
              },
              [
                _c("span", [_vm._v("Notification was sent successfully")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: `/#/sharing/resource/${_setup.resourceProviderName}/${_setup.resourceId}`,
                    },
                  },
                  [_c("strong", [_vm._v("Close")])]
                ),
              ]
            ),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }